import {
  Component,
  Inject,
  ChangeDetectionStrategy,
  TemplateRef,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Observable } from 'rxjs';

export interface DialogData {
  icon?: boolean;
  title?: string;
  innerTitle?: string;
  classes?: string;
  message?: string;
  sanitizedMessage?: string;
  templateRef?: TemplateRef<any>;
  approveBtnLabel?: string;
  denyBtnLabel?: string;
  isForbiddenPopup?: boolean;
  hideButtons?: boolean;
}

export function approveAction(
  dialog: MatDialog,
  dialogData: DialogData,
  width = '480px',
): Observable<boolean> {
  return dialog
    .open(ApproveDialogComponent, {
      data: dialogData,
      width: width,
      panelClass: ['mat-w-90pct-u-custsm', 'mat-h-85pct-u-custsm'],
    })
    .afterClosed();
}

@Component({
  selector: 'app-approve-dialog',
  templateUrl: './approve-dialog.component.html',
  styleUrls: ['./approve-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApproveDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ApproveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  onApprove(): void {
    this.dialogRef.close(true);
  }

  onDecline(): void {
    this.dialogRef.close(false);
  }

  onClose(): void {
    this.dialogRef.close(undefined);
  }
}
